module.exports = __webpack_public_path__ + "img/dashboard_fault_title_en.3af97758.png";